<template>
    <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow"
            >mdi-reload</v-icon
          >
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox
            class="no-display"
            v-model="registration_no"
            @change="checkHistory"
            :loading="comp_load"
            rounded
            :items="stud_list"
            label="Select Student"
            item-text="name"
            outlined
            dense
            prepend-icon="mdi-account-child-circle"
          ></v-combobox>
        </v-col>
      </v-row>
      <div v-if="registration_no != null">
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table
                  :headers="headers_1"
                  :items="ay_record"
                  class="elevation-1 mytable"
                  dense
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table
                  :headers="headers_2"
                  :items="ay_record_div"
                  dense
                  class="elevation-1 mytable"
                >
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group
            v-model="fetch_gen_toggle"
            mandatory
            row
            class="radiobtn"
          >
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50"
              >Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
    </v-card>
    <div v-if="registration_no != null">
      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="last_date_of_school"
                @blur="date = parseDate(last_date_of_school)"
                v-on="on"
                hint="Last Date of Leaving"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="gen_date"
                @blur="date = parseDate(gen_date)"
                v-on="on"
                hint="Generation Date"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="application_date"
                @blur="date = parseDate(application_date)"
                v-on="on"
                hint="Date Of Application"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_of_application"
              no-title
              @input="menu4 = false"
              @change="setToText()"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="issue_date"
                @blur="date = parseDate(issue_date)"
                v-on="on"
                hint="Date Of Issue"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              label="Issue Date"
              v-model="date_of_issue"
              no-title
              @input="menu3 = false"
              @change="setToText2()"
            ></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="progress"
              rounded
              :items="dvt_prog"
              label="Select Progress"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="conduct"
              rounded
              :items="dvt_conduct"
              label="Select Conduct"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="remark"
              rounded
              :items="dvt_remark"
              label="Select Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="reason"
              rounded
              :items="dvt_reason"
              label="Select Reason"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox
            color="#0f2027"
            v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"
          ></v-checkbox>
        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <br />
      </template>
        <div id="document1" class="printdiv" v-if="lc_data != null">
          <v-row>
            <v-col cols="3" sm="3" md="3" align="right">              
                <img
                  :src="org_basic_data.school_logo"
                  alt="school_logo"
                  height="140px"
                  width="170px"
                />             
            </v-col>
            <v-col cols="6" sm="6" md="6">
              <center>
                <p>{{ org_basic_data.trust_name }}</p>
                <h1 style="text-transform: uppercase;">
                  {{ org_basic_data.school_name }}
                </h1>
                <p>( CBSE Affiliation - {{ org_basic_data.cbsc_no }})</p>
                <p>{{ org_basic_data.address }}&nbsp;</p>&nbsp;&nbsp;<p>Pin - {{org_basic_data.pin}}</p>
                <p>U - Dise : {{ lc_data.udise_no }}</p>
              </center>
            </v-col>
            <v-col cols="3" sm="3" md="3"></v-col>
          </v-row>
          <hr style="border: 1px dashed black">
          <v-row>
            <v-col cols="4" sm="4" md="4"><b>LC No:</b> {{ lc_data.certificate_no }}</v-col>
            <v-spacer></v-spacer>
            <v-col cols="4" sm="4" md="4"><b>Student Id:</b> {{ lc_data.saral_id }}</v-col>
          </v-row>
          <h2 align="center">TRANSFER / LEAVING CERTIFICATE</h2>
          <div class="text-center" style="border: 1px solid black; width: 100%;"><b>ORIGINAL</b></div>
          <table class="lc-table">            
            <tr>
              <td>Gr.No. </td>
              <td>{{ lc_data.gr_number }}</td>
            </tr>
            <tr>
              <td>Name of the Pupil </td>
              <td style="text-transform: uppercase;">{{ lc_data.fullname }}</td>
            </tr>
            <tr>
              <td>Father's / Guardian's Name</td>
              <td style="text-transform: uppercase;">{{ lc_data.father_full_name }}</td>
            </tr>
            <tr>
              <td>Mother's Name </td>
              <td style="text-transform: uppercase;">{{ lc_data.mother_first_name }}</td>
            </tr>
            <tr>
              <td>Nationality </td>
              <td style="text-transform: uppercase;">{{ lc_data.nationality }}</td>
            </tr>
            <tr>
              <td>Religion & Caste </td>
              <td style="text-transform: uppercase;">{{ lc_data.religion }} - {{ lc_data.caste }}</td>
            </tr>
            <tr>
              <td>Whether the candidate belongs to Schedule Cast or Schedule Tribe or OBC </td>
              <td style="text-transform: uppercase;">{{ lc_data.subcaste }}</td>
            </tr>
            <tr>
              <td>Date of first admission in the school with class</td>
              <td>{{ lc_data.doa }}  GRADE - {{ lc_data.admittedstandard }}</td>
            </tr>
            <tr>
              <td>Previous School Name</td>
              <td style="text-transform: uppercase;">{{ lc_data.last_school }}</td>
            </tr>
            <tr>
              <td>Date of Birth according to Admission Register In Christian Era <br>(in figures and word ) </td>
              <td style="text-transform: uppercase;">{{ lc_data.dob_fig }} <br>({{ lc_data.dob_words }})</td>
            </tr>
            <tr>
              <td>Place of Birth </td>
              <td style="text-transform: uppercase;">{{ lc_data.birth_place }}</td>
            </tr>
            <tr>
              <td>Class in which Studying at the time of leaving (in figures and words ) </td>
              <td>GRADE - {{ lc_data.standard }} <span v-if="lc_data.std_in_words" style="text-transform: uppercase;">({{ lc_data.std_in_words }})</span></td>
            </tr>
            <tr>
              <td>School/Board Annual examination last taken with result </td>
              <!-- <td style="text-transform: uppercase;">{{ lc_data.last_school }}</td> -->
              <td>GRADE - {{ lc_data.standard }} <span v-if="lc_data.std_in_words" style="text-transform: uppercase;">({{ lc_data.std_in_words }})</span></td>
            </tr>
            <tr>
              <td>Whether failed, if so once/twice in the same class</td>
              <td style="text-transform: uppercase;">{{ Whether_failed_in_same_class }}</td>
            </tr>
            <tr>
              <td>Subjects Studied </td>
              <td>
                <ul style="list-style-type: none; padding: 0">
                    <li>
                      <span v-for="(course, index) in lc_data.courses" :key="index" style="text-transform: uppercase;">
                         {{ course.course_name }}<span v-if="index < lc_data.courses.length - 1">, </span>
                      </span>
                    </li>
                </ul> 
              </td>
            </tr>
            <tr>
              <td>Whether qualified for promotion to the higher class, if so to which class <br>(in figures and word ) </td>
              <!-- <td>--</td> -->
              <td>
                <span v-if="is_promoted_to_next_standard.name == 'Yes'">
                  GRADE - {{ promoted_standard.standard }}&nbsp;
                  <span v-if="promoted_standard_in_words" style="text-transform: uppercase;"> ({{ promoted_standard_in_words }})</span></span>
                <span v-else style="text-transform: uppercase;">{{ is_promoted_to_next_standard.name }}</span></td>
            </tr>
            <tr>
              <td>Whether NCC Cadet/Boy Scout/Girl Guide</td>
              <td style="text-transform: uppercase;">{{ whether_ncc_cadet }}</td>
            </tr>
            <tr>
              <td>Games Played or extra-curricular activities in which the pupil usually took part </td>
              <td style="text-transform: uppercase;">{{ lc_data.extra_curricular_activities }}</td>
            </tr>
            <tr>
              <td>General Progress </td>
              <td style="text-transform: uppercase;">{{ lc_data.progress }}</td>
            </tr>
            <tr>
              <td>General Conduct</td>
              <td style="text-transform: uppercase;">{{ lc_data.conduct }}</td>
            </tr>
            <tr>
              <td>Mother tongue</td>
              <td style="text-transform: uppercase;">{{ lc_data.mothertoungue }}</td>
            </tr>
            <tr>
              <td>Reason for leaving the school</td>
              <td style="text-transform: uppercase;">{{ lc_data.reason }}</td>
            </tr>
            <tr>
              <td>Any other remarks</td>
              <td>--</td>
            </tr>
            <tr>
              <td>Date of issue of certificate </td>
              <td>{{ lc_data.date_of_issue }}</td>
            </tr>
          </table>
          
          <b class="f-size">*No change in any entry in this certificate shall be made except by the authority issuing it, and any   
              infringement of this requirement is liable to involve the imposition of penalty as that of  rustication (Prescribed 
              by rule 17  Chapter  Ⅱ and rule  30 section Ⅲ of grant -in aid- code) 
          </b>
          <br><br><br><br><br>
          <v-row class="f-size pb-5">
            <v-col cols="4" sm="4" md="4" align="center"><b> Class Teacher Sign </b></v-col>
            <v-col cols="4" sm="4" md="4" align="center"><b> Checked by </b></v-col>
            <v-col cols="4" sm="4" md="4" align="center"><b> Principal sign with Seal & Date </b></v-col>
          </v-row>
          
        </div>
    </div>
    <div class="no-display" v-if="lc_data != null">
      <div style="text-align: center">
        ----------------------------------Modify------------------------------------
      </div>
      <br />

      <v-row justify="center" class="mt-3">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Progress"
            v-model.trim="lc_data.progress"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Conduct"
            v-model.trim="lc_data.conduct"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3" style="display: none;">
          <v-text-field
            label="Student Remark"
            v-model.trim="lc_data.remark"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Reason"
            v-model.trim="lc_data.reason"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small
          >Save</v-btn
        >
      </v-row>
      <hr />
      <v-row class="no-display">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Birth in words"
            v-model.trim="lc_data.dob_words"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Last School"
            v-model.trim="lc_data.last_school"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Standard"
            v-model.trim="lc_data.standard"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Since when..."
            v-model.trim="lc_data.standard_since_when"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Caste"
            v-model.trim="lc_data.caste"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Religion"
            v-model.trim="lc_data.religion"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Whether failed, once / twice in the same class	"
            v-model.trim="Whether_failed_in_same_class"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <span>Is Promoted To Next Standard</span>
          <v-combobox
            v-model="is_promoted_to_next_standard"
            rounded
            :items="is_promoted_to_standard"
            label="Select Option"
            item-value="name"
            item-text="name"
            @change="setnextstandard(is_promoted_to_next_standard)"
            outlined
            dense
            persistent-hint
          ></v-combobox>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
              v-if="show_promoted_standards == true"
            >
            <span>Select Standard To Which Student Will Promoted</span>
              <v-combobox
                v-model="promoted_standard"
                rounded
                :items="standard_list"
                label="Select Standard"
                item-value="standard"
                item-text="standard"
                outlined
                dense
                persistent-hint
              ></v-combobox>
        </v-col>
        <v-col cols="12" sm="3" md="3" class="mt-3">
            <v-text-field
              label="Whether NCC Cadet/Boy Scout/ Girl Guide"
              v-model.trim="whether_ncc_cadet"
            ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3" class="mt-3">
            <v-text-field
              label="Games played or extra-curricular activities in which the pupil usually took part (mention achievement level therein)"
              v-model.trim="lc_data.extra_curricular_activities"
            ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-btn @click="proceed" class="info">Proceed to print</v-btn>
      </v-row>
    </div> 
    </div>   
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
      data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      board_toggle: "SSC",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      application_date: "",
      issue_date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      condition: false,
      org_id: null,
      Whether_failed_in_same_class: "",
      is_promoted_to_next_standard: "",
      promoted_standard: "",
      is_promoted_to_standard: [
        { name: "Yes", id: "1" },
        { name: "No", id: "2" },        
      ],
      standard_list: [],
      promoted_standard_in_words: "",
      show_promoted_standards: false,
      whether_ncc_cadet: "",
      extra_curricular_activities: [],
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
      this.lc_data.date_of_issue = this.issue_date;
    },
  },
  methods: {
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    setToText2() {
      this.lc_data.date_of_issue = this.issue_date;
    }, 
  //   updateStandardList() {
  //     console.log("in method");
  //     console.log("std "+ this.lc_data.standard);
  //   if (this.lc_data.standard === "X") {
  //     console.log("in if");
  //     const exists = this.standard_list.some((item) => item.standard === "XI");
  //     if (!exists) {
  //       this.standard_list.push({
  //         standard: "XI",
  //         std_in_words: null,
  //         is_new_admission_fee_applicable_logic: false,
  //         id: null,
  //         nextstandard: null,
  //       });
  //     }
  //   }  
  // }, 
    setnextstandard(item) {
     //  alert("item::"+item.name)
      if (item.name == "Yes") {
        this.show_promoted_standards = true;
        this.promoted_standard = this.lc_data.nextstandard;
        this.promoted_standard_in_words = this.lc_data.next_std_in_words;
      } else {
        this.show_promoted_standards = false;
      }
    },
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
        gen_date: this.date_of_generation,
      };
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Success..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      localStorage.setItem(
        "is_promoted_to_next_standard",
        JSON.stringify(this.is_promoted_to_next_standard)
      );
      localStorage.setItem(
        "Whether_failed_in_same_class",
        JSON.stringify(this.Whether_failed_in_same_class)
      );
      localStorage.setItem(
        "whether_ncc_cadet",
        JSON.stringify(this.whether_ncc_cadet)
      );
      let routeData = this.$router.resolve({ name: "sav-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            this.standard_list = res.data.standard_list;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null &&
        this.application_date != "" &&
        this.issue_date != ""
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          mark_inactive: this.mark_inactive,
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              // this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);

            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "");
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
    this.org_id = localStorage.getItem("EPS-org-id")
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.mytable1 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
.expapanel {
  width: 93%;
  margin-left: 3%;
}
.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}
.fees span {
  font-size: 23px;
  font-weight: 600;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: white; 
  padding: 0px 25px; 
 margin: 4px 0;
  white-space: nowrap;
}
.lc-table, .lc-table td, .lc-table tr{
  border: 1px solid black;
  border-collapse: collapse;
  text-align: left;
  font-size: medium;
  font-weight: 400;
}
.lc-table {
  width: 100%;
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 500;
}
/* lc data css end */

/* print lc css */
@media print {
  .pagebreak {
    page-break-before: always;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
    margin-left: -12px;
  }
  #document1 {
    position: absolute;
    margin-top: -75px;
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .lc-table td, .lc-table tr {
    font-size: 18px !important;
    padding: 3px !important;
  }
  .lc-table {
    line-height: 160% !important;      
  }
  p {
    font-size: medium;
  }
  .f-size {
    font-size: large;
  }
  @page {
    size: A4;
    margin: none;
    margin-top: 22px;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */

span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1); /* Safari and Chrome */
  -moz-transform: scale(1.5, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
}
</style>